import React from "react";
import ReactApexChart from "react-apexcharts";
import { Typography } from "antd";
import lineChart from "./lineChart";

function InquiriesChart({ inquiriesTimeline }) {
  const { Title } = Typography;

  // Extract dates and counts from the inquiriesTimeline object
  const dates = Object.keys(inquiriesTimeline);
  const counts = Object.values(inquiriesTimeline);
  const lineWidth = Math.max(720, dates.length * 64);
  const tickAmount = Math.min(dates.length, 8);

  if (!dates.length) {
    return (
      <div className="dashboard-empty-state">No inquiry trend data yet.</div>
    );
  }

  const updatedLineChartOptions = {
    ...lineChart.options,
    xaxis: {
      ...lineChart.options.xaxis,
      categories: dates,
      tickAmount,
    },
    colors: ["#5FCBA0"], // You can adjust the color as per your needs
  };

  const updatedLineChartSeries = [
    {
      name: "Number of Inquiries",
      data: counts,
    },
  ];

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Lead Flow</span>
          <Title level={5}>Inquiries Over Time</Title>
          <span className="dashboard-panel__subtext">
            Measure contact demand and watch for spikes in outreach activity.
          </span>
        </div>
        <span className="dashboard-panel__metric">{counts.length}</span>
      </div>
      <div className="dashboard-panel__chart">
        <div className="dashboard-panel__chart-inner" style={{ minWidth: lineWidth }}>
        <ReactApexChart
          options={updatedLineChartOptions}
          series={updatedLineChartSeries}
          type="area"
          height={320}
          width="100%"
        />
        </div>
      </div>
    </div>
  );
}

export default InquiriesChart;
